import React, { FC } from 'react'
import { SkeletonBox, Flex } from '@moonpig/launchpad-components'
import { SkeletonProductGrid } from '../productGrid'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'

const StyledSkeletonTabs = styled(Flex)`
  ${s({
    gap: 16,
    borderBottom: '1px solid',
    borderColor: 'colorBorder03',
    mb: 6,
    px: { xs: 5, md: 8 },
    py: 4,
  })}
`

const StyledSkeletonProductGrid = styled(SkeletonProductGrid)`
  ${s({
    mx: { xs: 5, md: 10 },
  })}
`
export const MoreLikeThisTabsSkeleton: FC<{ numberOfTabs: number }> = ({
  numberOfTabs,
}) => (
  <>
    <StyledSkeletonTabs>
      {Array.from({ length: numberOfTabs }).map((_, index) => (
        <SkeletonBox
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          data-testid="more-like-this-tab-skeleton"
          width="170px"
          height="32px"
          borderRadius={1}
          colours={{
            background: 'colorBlack05',
            effect: 'colorBlack10',
          }}
        />
      ))}
    </StyledSkeletonTabs>
    <StyledSkeletonProductGrid />
  </>
)
